<template>
	<Modal v-if="shown"
		   :title="$t('prospectiveReceivableSnapshot.modal.title')"
		   :width="768"
		   :close-on-click-outside="true"
		   @close="show(false)"
	>
		<template v-slot:body>
			<div class="flex  text_left modal-content">
				<div class="flex flex_column flex_1 base_padding">
					<h4 class="info_title">{{ formatAsLocalizedEnum(enumDef.receivableType, info.type) }}</h4>
					<md-field displayOnly>
						<label>{{ $t("common.invoiceNumber") }}</label>
						<md-input :value="info.invoiceNumber" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{ $t("common.seller") }}</label>
						<md-input :value="info.sellerName" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{ $t("common.seller.country") }}</label>
						<md-input :value="info.sellerCountry" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{ $t("common.debtor") }}</label>
						<md-input :value="info.debtorName" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{ $t("common.debtor.country") }}</label>
						<md-input :value="info.debtorCountry" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{ $t("seller.upload.ApplicableLaw") }}</label>
						<md-input :value="info.applicableLaw" disabled></md-input>
					</md-field>
				</div>
				<div class="flex flex_column flex_1 base_padding">
					<h4 class="info_title">{{ $t('prospectiveReceivableSnapshot.modal.paymentDetails') }}</h4>
					<md-field displayOnly>
						<label>{{ $t("common.invoiceDate") }}</label>
						<md-input :value="formatAsLocalizedDate(info.invoiceDate)" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{ $t("common.dueDate") }}</label>
						<md-input :value="formatAsLocalizedDate(info.dueDate)" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{ $t("common.totalAmount") }}</label>
						<md-input :value="formatAsMoneyAmount(info.amount, { currency: info.currency })" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{ $t("common.payoutAmount") }}</label>
						<md-input :value="formatAsMoneyAmount(info.payoutAmount, { currency: info.currency })" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{ $t("common.irr.expected") }}</label>
						<md-input :value="formatAsPercentage(info.investorTargetIrrRatePerAnnumCapped)" disabled></md-input>
					</md-field>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>

import Modal from "@/components/templates/modal/Modal";
import {formatAsLocalizedDate, formatAsLocalizedEnum, formatAsMoneyAmount, formatAsPercentage} from "@/common/format";
import {enumDef} from "@/common/enumDefs";

export default {
	computed: {
		enumDef() {
			return enumDef
		}
	},
	components: {
		Modal,
	},
	data() {
		return {
			shown: false,
			info: {}
		};
	},
	methods: {
		formatAsMoneyAmount,
		formatAsPercentage,
		formatAsLocalizedDate,
		formatAsLocalizedEnum,
		loadSnapshotValues(loadingPromise) {
			loadingPromise
				.then((res) => {
					this.info = res;
				})
				.catch(this.toast);
		},
		show(value) {
			this.shown = value;
		},
		showWithData(loadingPromise) {
			this.loadSnapshotValues(loadingPromise);
			this.show(true);
		}
	}
};
</script>